import { message } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import {
  baseUrl,
  GET_COMPANIES_LIST,
  HEADERS_EXPORT,
} from "../../../API/apiUrls";
import TokenCheck from "../../../../hook/TokenCheck";

const LoadCompanies = () => {
  const [companiesList, setCompaniesList] = useState([]);
  const [loadingDataCompany, setLoadingDataCompany] = useState(false);
  const [signOut] = TokenCheck();
  useEffect(() => {
    if (loadingDataCompany) {
      loadData();
    }
  }, [loadingDataCompany]);

  const loadData = async () => {
    console.log("loadData LoadCompanies");

    try {
      // 1. รอรับผลลัพธ์ด้วย await ทันที ไม่ต้องใช้ .then()
      const response = await axios.get(baseUrl + GET_COMPANIES_LIST, {
        headers: HEADERS_EXPORT,
      });

      // 2. ถ้าโค้ดมาถึงบรรทัดนี้ได้ แปลว่าสถานะคือ 2xx (Success) แน่นอน
      setCompaniesList(response.data);
      console.log("res", response.data);
    } catch (error) {
      // 3. จัดการ Error ทุกอย่างที่นี่ที่เดียว (ใช้ Optional Chaining '?.' เพื่อกันแอปพัง)
      if (error.response?.data === "Session expired") {
        signOut();
      } else {
        setCompaniesList([]);
        console.error("Error fetching data:", error);

        // แจ้งเตือนข้อผิดพลาดให้ User ทราบ
        const errorMessage =
          error.response?.data?.message || "เกิดข้อผิดพลาดในการดึงข้อมูล";
        message.error(errorMessage);
      }
    }
  };

  return [companiesList, setLoadingDataCompany];
};

export default LoadCompanies;
